export default "__VITE_ASSET__ChU_8BNR__"